module.exports = __webpack_public_path__ + "static/media/tornado.fa5dde6f.svg";